<template>
  <footer>
    <div class="con1 pn ">
      <div class="contact">
        <div class="footer-info info-start">
          <div class="title">
            <span>联系我们</span>
          </div>
          <div class="txt">
            <span>指导单位:&nbsp;{{ guidingUnit }}</span>
          </div>
          <div class="txt top">
            <span>主办单位:&nbsp;{{ hostOrganization }}</span>
          </div>
          <div class="txt top">
            <span>技术支持单位: {{ technicalUnit }}</span>
          </div>
          <div class="txt top" style="cursor: pointer">
            <span @click="toWeb">网站备案号: {{ recordNumber }}</span>
          </div>
        </div>
      </div>
      <div class="help" v-if="path !== 'login' && path !== 'register'">
        <div class="txt hover">
          <span @click.stop="showDownLoad">帮助与支持</span>
        </div>
      </div>
      <div class="QR">
        <div class="QR-item APP">
          <div class="hd">APP下载</div>
          <div class="bd">
            <img
                :src="require('../assets/images/qrcode.jpg')"
                width="100"
                height="100"
            />
          </div>
        </div>
        <div class="QR-item APP">
          <div class="hd">扫码关注</div>
          <div class="bd">
            <img
                :src="WXCodeTicket ? 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + WXCodeTicket
                : require('../assets/images/wxQrcode.jpg') "
                width="100"
                height="100"
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="guideBox" title="" :visible.sync="guideTableVisible">
      <template #title>
        <el-tabs v-model="current" @tab-click="handleClick">
          <el-tab-pane label="家长指南" name="1"></el-tab-pane>
          <el-tab-pane label="教师指南" name="2"></el-tab-pane>
        </el-tabs>
      </template>
      <el-table :data="list" max-height="500">
        <el-table-column property="fileName" label="文件名">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center; flex-wrap: nowrap;">
              <el-image style="margin-right: 16px;width: 36px;height: 36px;flex: none"
                        :src="formatFileIcon(scope.row.fileName)"></el-image>
              <div class="guide-text">{{ scope.row.fileName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            header-align="center"
            align="center"
            width="120">
          <template slot-scope="scope">
            <div style="display: flex; gap: 10px; justify-content: center;">
              <el-image class="guide-btn" :src="require('@/assets/images/home/ico_preview.png')"
                        @click.stop="previewFile(scope.row)"></el-image>
              <el-image class="guide-btn" :src="require('@/assets/images/home/ico_download.png')"
                        @click.stop="downloadFile(scope.row)"></el-image>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </footer>
</template>
<script>
import {getGuideList} from "@/api/home";
import {Base64} from "js-base64";

export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      guidingUnit: "福建省福州市鼓楼区教育局", // 指导单位
      hostOrganization: "福州市鼓楼区国有资产投资发展集团有限公司", // 主办单位
      technicalUnit: "福建数创联合科技有限公司",
      recordNumber: "闽ICP备11009183号-3", // 备案号
      WXCodeTicket: null,
      path: this.$route.name,
      guideTableVisible: false,
      queryParams: {
        pageNum: 1,
        pageSize: 100,
        type: 1, // 请求来源 1家长 2老师
      },
      list: [],
      current: '1'
    };
  },
  watch: {},
  computed: {},
  created() {
  },
  mounted() {
    this.getCode();
  },
  methods: {
    async getCode() {
      // try {
      //   const wxQrCode = localStorage.getItem("wxQrCode");
      //   if (this.WXCodeTicket) {
      //     return;
      //   }
      //
      //   if (!wxQrCode) {
      //     return;
      //   }
      //   this.WXCodeTicket = wxQrCode;
      // } catch (err) {
      //   console.log(err);
      // }
    },
    formatFileIcon(fileName) {
      let defaultIcon = require("@/assets/images/home/ico_file.png");
      // 如果文件名没有后缀（没有 .），返回默认图标
      if (!fileName || !fileName.includes('.')) {
        return defaultIcon;  // 没有扩展名时返回默认图标
      }

      const fileExtension = fileName.split('.').pop().toLowerCase(); // 获取文件扩展名并转小写

      let icon;
      switch (fileExtension) {
        case 'doc':
        case 'docx':
          icon = require('@/assets/images/home/ico_word.png'); // Word文件
          break;
        case 'xls':
        case 'xlsx':
          icon = require('@/assets/images/home/ico_excel.png'); // Excel文件
          break;
        case 'ppt':
        case 'pptx':
          icon = require('@/assets/images/home/ico_ppt.png'); // PowerPoint文件
          break;
        default:
          icon = defaultIcon; // 默认图标
      }
      return icon;
    },
    getList() {
      getGuideList(this.queryParams).then((res) => {
        this.$set(this, 'list', res.rows || [])
      })
    },
    handleClick(tab, event) {
      this.queryParams.type = tab.name;
      this.getList();
    },
    showDownLoad() {
      if (this.path === 'login') return this.$alert('请先登录再使用该功能！');
      this.getList();
      this.$nextTick(() => {
        this.guideTableVisible = true;
      })
    },
    downloadFile(file) {
      setTimeout(() => {
        window.open(
            process.env.VUE_APP_BASE_API +
            "/system/File/downOssFile?uuid=" +
            file.fileId, '_blank'
        );
      });
    },
    toWeb() {
      window.open("https://beian.miit.gov.cn", '_blank');
    },
    previewFile(file) {
      // 输入校验
      if (!file?.fileId) {
        this.$message.error("文件不存在或缺少文件ID");
        return;
      }

      try {
        // 常量定义
        // const BASE_API = "http://192.168.26.127:9530/prod-api";
        const BASE_API = window.location.origin + process.env.VUE_APP_BASE_API;
        const DOWNLOAD_ENDPOINT = "/system/File/downOssFile";

        // **手动拼接下载链接**
        const downloadLink = `${BASE_API}${DOWNLOAD_ENDPOINT}?uuid=${file.fileId}&fullfilename=${file.fileName}`;
        console.log("下载链接:", downloadLink);

        // 预览链接处理
        const previewLink = process.env.VUE_APP_FILE_PREVIEW_URL;
        const encodedPath = Base64.encode(downloadLink); // 只进行 Base64 编码
        const finalPreviewUrl = `${previewLink}${encodedPath}`;

        // 执行预览
        window.open(finalPreviewUrl, '_blank');

      } catch (error) {
        console.error('文件预览失败:', error);
        this.$message.error('文件预览失败，请稍后重试');
      }
    }
  },
};
</script>
<style scoped>
footer {
  height: 208px;
  background: #076bf2;
  color: #fff;
}

footer .con1 {
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding: 25px 0;
}

footer .con2 {
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: 500;
  line-height: 32px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  padding: 6px 0;
}

footer .con1 .hd {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: bold;
  line-height: 32px;
}

footer .con1 .contact {
  display: flex;
  justify-content: space-between;
  padding-right: 100px;
  height: 146px;

  .title {
    font-weight: 700;
    font-size: 20px;
    line-height: 36px;
  }

  .txt {
    font-weight: 400;
    font-size: 18px;
    line-height: 36px;
    color: #FFFFFFD9;
  }

}

.help {
  .txt {
    font-weight: 400;
    font-size: 18px;
    line-height: 36px;
  }

  .hover {
    cursor: pointer;
  }

  .hover:hover {
    color: rgba(255, 255, 255, 0.8);
  }
}

footer .con1 .QR {
  display: flex;
}

.contact .hd {
  margin-bottom: 10px;
}

.contact-list .item {
  display: flex;
}

.contact-list .item .tit {
  width: 6em;
  line-height: 2.4em;
  font-size: 14px;
}

.QR-item {
  padding: 0 20px;
  text-align: center;
}

.QR-item .hd {
  margin-bottom: 10px;
}

.QR-item .bd img {
  border-radius: 5px;
}

.footer-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

}

.info-center {
  align-items: center;
}

.info-start {
  align-items: start;
}

.guideBox >>> .el-dialog__header {
  padding-left: 0;
  padding-right: 0;
}

.guideBox >>> .el-dialog__body {
  padding: 0 32px 32px 32px;
}

.guideBox >>> .el-tabs__nav {
  margin-left: 32px;
}

.guideBox >>> .el-table .cell {
  font-size: 18px;
  font-weight: 400;
  color: rgba(76, 89, 109, 1);
}

.guideBox >>> .el-tabs__item {
  font-size: 20px;
  font-weight: 500;
}

.guideBox >>> .el-tabs__item.is-active {
  font-size: 22px;
  font-weight: 700;
}

.guide-text {
  display: flex;
  align-items: center;
  font-size: 18px;
  overflow: hidden;
}

.guide-btn {
  width: 28px;
  height: 28px;
  cursor: pointer;

  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.3);
  }
}
</style>
